import React, { useState } from 'react';

import Tippy from '@tippyjs/react';

import { ia } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import PayerAltNamesModal from './PayerAltNamesModal';

const PayerNameWithInfo = ({ payer }) => {
  const altNames = payer?.payerAltNames || [];
  const hasAltNames = ia(altNames);
  const status = payer?.status; // 0 is for pending approval
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleIconClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (hasAltNames && status !== 0) {
      setIsModalOpen(true);
    }
  };

  const tippyContent =
    status === 0
      ? 'Status: Pending approval'
      : hasAltNames
        ? 'Click to see all other known names for this payer'
        : 'This payer has no other known names.';

  return (
    <>
      <div className="flex gap-2">
        <Tippy
          interactive
          content={tippyContent}
          className="tippy-dark arrow-small"
          appendTo={document.body}>
          <div
            className={`flex ${hasAltNames ? 'cursor-pointer' : ''}`}
            data-payer-info-icon
            onClick={handleIconClick}>
            <Icon
              icon="info-mono"
              size={16}
              color={status === 0 ? 'warning' : 'neutral'}
              shade={600}
            />
          </div>
        </Tippy>

        <span>{payer?.name || '-'}</span>
      </div>

      <PayerAltNamesModal
        isOpen={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        altNames={altNames}
      />
    </>
  );
};

export default PayerNameWithInfo;
